import React, { useEffect } from "react";
import {
  HashRouter as Router,
  Route,
  Routes,
  useNavigate,
  useLocation,
  matchPath,
} from "react-router-dom";
import Inscription from "./Page/Utilisateur/Compte/Inscription";
import CreateBets from "./Page/Bets/Create/CreateBets";
import CreateMiniBets from "./Page/Bets/Create/CreateMiniBets";
import CreateFlash from "./Page/Bets/Create/CreateFlash";
import Home from "./Page/Bets/Affichage_Home/Home";
import Connexion from "./Page/Utilisateur/Compte/Connexion";
import BottomNavBar from "./Components/BottomNavbar";
import ButtonAppBar from "./Components/TopNavbar";
import ManageBets from "./Page/Bets/Manage/ManageBets";
import UsersList from "./Page/Utilisateur/Liste Joueurs/ListUser";
import Collection from "./Page/Cartes/Collection";
import PackOpening from "./Page/Cartes/Packopening";
import Messagerie from "./Page/Utilisateur/Compte/Messagerie";
import PageFlash from "./Page/Flash/pageFlash";
import ManageMiniBet from "./Page/Bets/Manage/ManageMiniBets";
import AddOrganisation from "./Page/SuperAdmin/AddOrganisation";
import Dashboard from "./Page/Admin/Dashboard";
import AttenteInscription from "./Page/Utilisateur/Compte/AttenteInscription";
import AddCard from "./Page/Admin/AddCard";
import Collections from "./Page/Admin/Collections";
import CreateCollection from "./Page/Admin/CreateCollection";
import CollectionChoix from "./Page/Cartes/CollectionChoix";
import CollectionCards from "./Page/Cartes/CollectionCards";

// import WorkInProgress from "./Page/Bets/WorkInProgress";

import { UserProvider, useUser } from "./Services/ContexteUser";

/**
 * Quick fix pour Instagram / HashRouter :
 * - Si l'URL contient ?r=/inscription et AUCUN hash, on reconstruit le hash (/#/inscription)
 * - Usage : partager https://betkiff.netlify.app/?r=/inscription
 */
function InstagramHashFix() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const r = params.get("r");
    // Si on arrive de l'Instagram Link Shim, souvent le fragment # est perdu.
    if (!window.location.hash && r) {
      const normalized = r.startsWith("/") ? r : `/${r}`;
      // replace() pour ne pas polluer l'historique
      window.location.replace(`/#${normalized}`);
    }
  }, []);
  return null;
}

function NavigationWrapper() {
  const location = useLocation();
  const navigate = useNavigate();

  // ⛔️ Supprime le token hardcodé — on lit le vrai token depuis le localStorage
  const token = localStorage.getItem("authToken") || null;
  // eslint-disable-next-line
  const { user, loading } = useUser(); // Accès aux informations de l'utilisateur

  useEffect(() => {
    // Pages d'auth publiques
    const isAuthPage =
      location.pathname === "/connexion" ||
      matchPath("/inscription", location.pathname) ||
      location.pathname === "/attenteInscription";

    if (!token && !isAuthPage) {
      navigate("/connexion", { replace: true });
    }

    // Uniformiser le flux : redirige /attenteInscription vers /inscription
    if (location.pathname === "/attenteInscription") {
      navigate("/inscription", { replace: true });
    }
  }, [navigate, location.pathname, token]);

  const hideNav =
    matchPath("/inscription", location.pathname) ||
    location.pathname === "/connexion" ||
    matchPath("/createBet", location.pathname) ||
    matchPath("/createMiniBet", location.pathname) ||
    matchPath("/createFlash", location.pathname) ||
    location.pathname === "/flash" ||
    location.pathname === "/packopening" ||
    matchPath("/manageBets/:idBet", location.pathname) ||
    matchPath("/manageMiniBets/:idBet", location.pathname) ||
    location.pathname === "/attenteInscription";

  if (loading) {
    return <div>Loading...</div>; // Affiche un loader pendant que les données utilisateur sont récupérées
  }

  return (
    <>
      {!hideNav && <ButtonAppBar />}
      <Routes>
        <Route path="/" element={<Home />} />

        <Route path="/connexion" element={<Connexion />} />
        <Route path="/inscription" element={<Inscription />} />
        <Route path="/createBet" element={<CreateBets />} />
        <Route path="/createMiniBet" element={<CreateMiniBets />} />
        <Route path="/createFlash" element={<CreateFlash />} />
        <Route path="/manageBets/:idBet" element={<ManageBets />} />
        <Route path="/userlist" element={<UsersList />} />
        <Route path="/collection" element={<Collection />} />
        <Route path="/packopening" element={<PackOpening />} />
        <Route path="/messagerie" element={<Messagerie />} />
        <Route path="/flash" element={<PageFlash />} />
        <Route path="/manageMiniBets/:idBet" element={<ManageMiniBet />} />
        <Route path="/addorganisation" element={<AddOrganisation />} />

        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/addcards/:idCollection" element={<AddCard />} />
        <Route path="/collections" element={<Collections />} />
        <Route path="/createcollection" element={<CreateCollection />} />

        <Route path="/collectioncards" element={<CollectionCards />} />

        <Route path="/attenteInscription" element={<AttenteInscription />} />
        <Route path="/collectionChoix" element={<CollectionChoix />} />
      </Routes>
      {!hideNav && <BottomNavBar />}
    </>
  );
}

function App() {
  return (
    <div className="App">
      <UserProvider>
        <Router>
          {/* Doit être à l'intérieur du Router pour lire/écrire l'URL */}
          <InstagramHashFix />
          <NavigationWrapper />
        </Router>
      </UserProvider>
    </div>
  );
}

export default App;
